import { render, staticRenderFns } from "./ResumenCompraComponent.vue?vue&type=template&id=6a402cb8"
import script from "./ResumenCompraComponent.vue?vue&type=script&lang=js"
export * from "./ResumenCompraComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports